import { PendingDhsSsaItem } from '../../../application/domain/entities/PendingDhsSsaItem';
import { PendingDhsSsaResult } from '../../../application/domain/entities/PendingDhsSsaResult';
import { PendingEverifyItemDto } from '@/features/pending_everify/infra/repositories/dto/PendingEverifyItemDto';

export class PendingDhsSsaMapper {
  static toDomain(dto: PendingEverifyItemDto): PendingDhsSsaItem {
    return {
      everifyCaseId: dto.everifyCaseId,
      i9FormId: dto.i9FormId,
      currentStatus: dto.caseStatus,
      caseStatusDisplay: dto.caseStatusDisplay,
      dhsReferralStatus: dto.dhsReferralStatus,
      ssaReferralStatus: dto.ssaReferralStatus,
      firstName: dto.firstName,
      lastName: dto.lastName,
      name: `${dto.firstName} ${dto.lastName}`.trim(),
      ssn: dto.ssn,
      locationName: dto.locationName,
    };
  }

  static toDomainList(items: PendingEverifyItemDto[]): PendingDhsSsaResult {
    return {
      items: items.map((item) => this.toDomain(item)),
    };
  }
}
